import o from 'react';
import { CampaignContext } from './src-context-CampaignContext.js';
import { useCampaignCallouts } from './src-hooks-useCampaignCallouts.js';

const CampaignProvider = (props) => {
  const {
    tenant,
    locale,
    previewDate
  } = props;
  const { callouts, skin, isLoading } = useCampaignCallouts(tenant, locale, previewDate, "provider");
  return /* @__PURE__ */ o.createElement(
    CampaignContext.Provider,
    {
      value: { tenant, locale, callouts, skin, isLoading }
    },
    props.children
  );
};

export { CampaignProvider as default };
//# sourceMappingURL=src-providers-CampaignProvider.js.map
